import React, { useRef, lazy } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { ScrollReveal } from './ScrollReveal';
export const Technology = () => {
  const ref = useRef(null);
  const {
    scrollYProgress
  } = useScroll({
    target: ref,
    offset: ['start end', 'end start']
  });
  const yText = useTransform(scrollYProgress, [0, 1], ['0%', '15%']);
  const yImage = useTransform(scrollYProgress, [0, 1], ['0%', '-10%']);
  return;
};